function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  const message = error.message.toLowerCase();
  return (
    message.includes('failed to fetch dynamically imported module') ||
    message.includes('loading chunk') ||
    message.includes('loading css chunk') ||
    message.includes('unable to preload css') ||
    message.includes("couldn't resolve module")
  );
}

export function lazyWithRetry<T>(importFn: () => Promise<T>): () => Promise<T> {
  return async () => {
    const RELOAD_KEY = 'chunk_reload_attempted';
    const RELOAD_TIMESTAMP_KEY = 'chunk_reload_timestamp';
    const RELOAD_COOLDOWN = 10000;

    try {
      const result = await importFn();
      sessionStorage.removeItem(RELOAD_KEY);
      sessionStorage.removeItem(RELOAD_TIMESTAMP_KEY);
      return result;
    } catch (error) {
      if (isChunkLoadError(error)) {
        const lastReloadTime = sessionStorage.getItem(RELOAD_TIMESTAMP_KEY);
        const now = Date.now();

        if (lastReloadTime && now - parseInt(lastReloadTime, 10) < RELOAD_COOLDOWN) {
          console.error('Chunk load failed after reload attempt:', error);
          throw error;
        }

        sessionStorage.setItem(RELOAD_KEY, 'true');
        sessionStorage.setItem(RELOAD_TIMESTAMP_KEY, now.toString());

        const url = new URL(window.location.href);
        url.searchParams.set('_reload', now.toString());
        window.location.replace(url.toString());

        return new Promise<T>(() => {});
      }

      throw error;
    }
  };
}
